!(function () {
    "use strict";
    const e = "[data-video-template]",
        t = "is-loading",
        i = "data-video-id",
        s = "data-disable-scroll-toggle";
    customElements.get("video-background") ||
        customElements.define(
            "video-background",
            class extends HTMLElement {
                constructor() {
                    super();
                }
                connectedCallback() {
                  (this.videoId = this.getAttribute(i)),
                  (this.videoTemplate = this.querySelector(e)),
                  (this.disableScrollToggle = this.hasAttribute(s)),
                  (this.video = null),
                  (this.powerSaverVideoPlay = this.powerSaverVideoPlay.bind(this)),
                  this.videoId && this.renderVideo();
                  this.playButton = this.parentElement.querySelector('.video__player--play');
                  if (this.playButton) { 
                    this.playButton.addEventListener('click', () => {
                        this.powerSaverVideoPlay();
                        this.setPlayButtonState();
                    });
                  }
                }
                setPlayButtonState() { 
                    if (!this.video) { 
                        return;
                    }

                    if (this.video.paused) {
                        this.playButton.classList.remove('is-playing');
                    } else {
                        this.playButton.classList.add('is-playing');
                    }
                }
                disconnectedCallback() {
                    this.videoTemplateObserver?.disconnect(),
                        this.videoPlayObserver?.disconnect(),
                        document.removeEventListener("click", this.powerSaverVideoPlay, !0),
                        document.removeEventListener("touchstart", this.powerSaverVideoPlay, !0),
                        this.videoId &&
                            (document.removeEventListener("click", this.powerSaverVideoPlay),
                            document.removeEventListener("touchstart", this.powerSaverVideoPlay));
                }
                powerSaverVideoPlay() {
                    this.video?.play();
                    this.setPlayButtonState();
                    
                }
                renderVideo() {
                    const templateSelector = "[data-video-template]";
                    const loadingClass = "is-loading";

                    this.videoTemplateObserver = new IntersectionObserver(
                        (entries, observer) => {
                            entries.forEach((entry) => {
                           
                                if (entry.isIntersecting) {
                                    const templateHTML = this.videoTemplate.innerHTML;
                                    this.innerHTML = templateHTML;
                                    this.classList.remove(loadingClass);
                                    this.video = this.querySelector("video");
                                    this.video.addEventListener('play', () => this.setPlayButtonState());
                                    this.video.addEventListener('pause', () => this.setPlayButtonState());
                                    this.observeVideoPlayToggle();
                                    if (this.playButton) { 
                                        return;
                                    }
                                    this.video
                                        .play()
                                        .then(() => {})
                                        .catch(() => {
                                            document.addEventListener("click", this.powerSaverVideoPlay, {
                                                passive: !0,
                                                bubbles: !0,
                                                once: !0,
                                            }),
                                                document.addEventListener("touchstart", this.powerSaverVideoPlay, {
                                                    passive: !0,
                                                    bubbles: !0,
                                                    once: !0,
                                                });
                                        }),
                                        observer.unobserve(entry.target);
                                }
                            });
                        },
                        { root: null, rootMargin: "300px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
                    ),
                        this.videoTemplateObserver.observe(this);
                }
                observeVideoPlayToggle() {
                    if (!this.video) return;

                    if (this.playButton) {
                        return;
                    }

                    if (this.disableScrollToggle) {
                        return;
                    }

                    this.videoPlayObserver = new IntersectionObserver(
                        (entries) => {
                            entries.forEach((entry) => {
                                const isVisible = entry.isIntersecting;

                                if (isVisible) {
                                    const playResult = this.video.play();
                                    if (playResult !== undefined) {
                                        playResult.then(() => {}).catch(() => {});
                                    }
                                } else if (typeof this.video.pause === "function") {
                                    this.video.pause();
                                }
                            });
                        },
                        { rootMargin: "0px", threshold: [0, 1] }
                    );
                    this.videoPlayObserver.observe(this.video);
                }
            }
        );
})();
